import { render, staticRenderFns } from "./tcxfPackage.vue?vue&type=template&id=79ddcfde&scoped=true"
import script from "./tcxfPackage.vue?vue&type=script&lang=js"
export * from "./tcxfPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ddcfde",
  null
  
)

export default component.exports